module.exports = __webpack_public_path__ + "img/denti_i_logo_miryang.4b0b2e97.png";